import { getError } from "@/utils/helpers"
import VentasService from "@/services/VentasService"

export const namespaced = true

function setPaginatedVentas(commit, response) {
  commit("SET_VENTAS", response.data.data)
  commit("SET_META", response.data.meta)
  commit("SET_LINKS", response.data.links)
  commit("SET_LOADING", false)
}

function setVentas(commit, response) {
  commit("SET_VENTAS_SIN_PAG", response.data.data)
}

export const state = {
  ventas: [],
  ventas_sin_pag: [],
  meta: null,
  links: null,
  dates: null,
  filters: null,
  loading: false,
  error: null
}

export const mutations = {
  SET_VENTAS(state, ventas) {
    state.ventas = ventas
  },
  SET_VENTAS_SIN_PAG(state, ventas) {
    state.ventas_sin_pag = ventas
  },
  SET_META(state, meta) {
    state.meta = meta
  },
  SET_LINKS(state, links) {
    state.links = links
  },
  SET_DATES(state, dates) {
    state.dates = dates
  },
  SET_FILTERS(state, filters) {
    state.filters = filters
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

export const actions = {
  async getVentas({commit, getters}, page) {
    commit("SET_LOADING", true)
    try {
      const dates = getters.dates_query
      const filters_query = getters.filters_query
      const response = await VentasService.getVentas(page, dates, filters_query)
      setPaginatedVentas(commit, response)

    } catch (error) {
      commit("SET_LOADING", false)
      commit("SET_ERROR", getError(error))
      // console.log(error)
    }
  },
  async getVentasAnuladas({commit, getters}, page) {
    commit("SET_LOADING", true)
    try {
      const dates = getters.dates_query
      const filters_query = getters.filters_query
      const response = await VentasService.getVentasAnuladas(page, dates, filters_query)
      setPaginatedVentas(commit, response)

    } catch (error) {
      commit("SET_LOADING", false)
      commit("SET_ERROR", getError(error))
      // console.log(error)
    }
  },
  async getVentasSinPaginacion({commit, getters}, page = false) {
    commit("SET_LOADING", true)
    try {
      const dates = getters.dates_query
      console.log(dates);
      // const filters_query = getters.filters_query
      const response = await VentasService.getVentasSinPaginacion(page, dates )
      setVentas(commit, response)

    } catch (error) {
      commit("SET_LOADING", false)
      commit("SET_ERROR", getError(error))
      // console.log(error)
    }
  },
  async paginateVenta({commit, getters}, link) {
    commit("SET_LOADING", true)
    try {
      const dates = getters.dates_query
      const filters_query = getters.filters_query
      const response = await VentasService.paginateVenta(link, dates, filters_query)
      setPaginatedVentas(commit, response)
    }catch(error)  {
      commit("SET_LOADING", false)
      commit("SET_ERROR", getError(error))
    }
  },
  setDates({commit}, dates) {
    commit("SET_DATES", dates)
  },
  setFilters({commit}, filters) {
    commit("SET_FILTERS", filters)
  }
}

export const getters = {
  ventas: (state) => {
    return state.ventas
  },
  ventasSinPaginacion: (state) => {
    return state.ventas_sin_pag
  },
  meta: (state) => {
    return state.meta
  },
  links: (state) => {
    return state.links
  },
  dates: (state) => {
    return state.dates
  },
  dates_query: (state) => {
    let dates_query = ""
    if (state.dates) {
      dates_query = `&start=${state.dates.start}&end=${state.dates.end}`
    }
    return dates_query
  },
  filters: (state) => {
    return state.filters
  },
  filters_query: (state) => {
    let filters_query = ""
    if (state.filters) {
      for (const [key,filter] of Object.entries(state.filters)) {
        if(!filter.fieldType || filter.fieldType == "group") {
          filters_query += `&filters[]=${key},${filter.value}`
        }else if(filter.fieldType && filter.fieldType == "single"){
          filters_query += `&${key}=${filter.value}`
        }
      }
    }
    return filters_query
  },
  loading: (state) => {
    return state.loading
  },
  error: (state) => {
    return state.error
  }
}